var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeOutlookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36113_473)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_36113_473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7083 4H7.87492C7.7137 4 7.58325 4.13045 7.58325 4.29167C7.58325 4.45288 7.7137 4.58333 7.87492 4.58333V10.4167C7.7137 10.4167 7.58325 10.5471 7.58325 10.7083C7.58325 10.8695 7.7137 11 7.87492 11H13.7083C13.8695 11 13.9999 10.8695 13.9999 10.7083V5.32503L13.977 4.58791L13.9999 4.29167C13.9999 4.13045 13.8695 4 13.7083 4Z",
    fill: "#0076BE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.7083 10.8542H7.87492C7.73959 10.8542 7.63096 10.7603 7.59796 10.6354C7.59165 10.6593 7.58325 10.6824 7.58325 10.7083C7.58325 10.8695 7.7137 11 7.87492 11H13.7083C13.8695 11 13.9999 10.8695 13.9999 10.7083V10.5625C13.9999 10.7237 13.8695 10.8542 13.7083 10.8542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 4.2917C14 4.26439 13.9915 4.23979 13.9845 4.21472L9.90926 7.52567L8.1416 6.16617C8.0621 6.10464 7.96814 6.08229 7.875 6.08236V7.06452L9.65007 8.43C9.72868 8.49067 9.82267 8.52086 9.91667 8.52086C10.0146 8.52086 10.1121 8.48811 10.1924 8.42288L14 5.32919V4.2917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.7083 4H7.87492C7.7137 4 7.58325 4.13045 7.58325 4.29167C7.58325 4.31755 7.59165 4.34069 7.59796 4.36458C7.63096 4.23969 7.73959 4.14583 7.87492 4.14583H13.7083C13.8695 4.14583 13.9999 4.27629 13.9999 4.4375V4.29167C13.9999 4.13045 13.8695 4 13.7083 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 0.5L0 2.02174V12.9783L8.16667 14.5V0.5Z",
    fill: "#0076BE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 2.02174V2.16758L8.16667 0.645833V0.5L0 2.02174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0 12.9782L8.16667 14.5V14.3541L0 12.8324V12.9782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79175 10.5625C2.56527 10.5625 1.60425 9.21724 1.60425 7.5C1.60425 5.78276 2.56527 4.4375 3.79175 4.4375C5.01823 4.4375 5.97925 5.78276 5.97925 7.5C5.97925 9.21724 5.01823 10.5625 3.79175 10.5625ZM3.79175 5.3125C3.08024 5.3125 2.47925 6.31425 2.47925 7.5C2.47925 8.68575 3.08024 9.6875 3.79175 9.6875C4.50326 9.6875 5.10425 8.68575 5.10425 7.5C5.10425 6.31425 4.50326 5.3125 3.79175 5.3125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7084 11C13.8696 11 14.0001 10.8695 14.0001 10.7083V9.8333L8.16675 4V11H13.7084Z",
    fill: "url(#paint0_linear_36113_473)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M8.16667 0.5L0 2.02174V12.9783L8.16667 14.5V0.5Z",
    fill: "url(#paint1_linear_36113_473)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 4.29167C14 4.13045 13.8695 4 13.7083 4H8.16667V0.5L0 2.02174V12.9783L8.16667 14.5V11H13.7083C13.8695 11 14 10.8695 14 10.7083V4.29167Z",
    fill: "url(#paint2_linear_36113_473)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36113_473",
    x1: 6.41675,
    y1: 5.75,
    x2: 12.7482,
    y2: 12.0815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36113_473",
    x1: -0.0773127,
    y1: 7.60739,
    x2: 8.10363,
    y2: 7.60739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_36113_473",
    x1: -1.07742,
    y1: 4.3325,
    x2: 13.7743,
    y2: 11.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36113_473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_36113_473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeOutlookIcon);
export default __webpack_public_path__ + "static/media/OfficeOutlookIcon.723fa7eb9dd434d0cbc4b395bdd2def1.svg";
export { ForwardRef as ReactComponent };